<template>
  <div id="userManage"  v-if="divVisible">
    <b>ユーザー一覧画面</b><br/><br/>

    <table>
      <tr>
        <td>ユーザー情報の更新いただけます。</td>
      </tr>
    </table><br/>

    <form onsubmit="return false;">
      <div class="bootstrap-table fixed-table-container" style="margin-bottom:10px;margin-bottom:10px;width: 100%;">
        <table id="rptHeader" class="table table-striped">
          <thead>
            <tr>
              <td>
                操作
              </td>
              <td>
                ｱｶｳﾝﾄ状態
              </td>
              <td>
                ユーザー
              </td>
              <td>
                ユーザータイプ
              </td>

            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in rows" v-bind:key="'row' + index">
              <td  width="50">
                <router-link :to="{ name: 'userDetail', params: { operationType: 'modify', memberID: row.memberID } }">
                  <img src="/static/images/icon-edit.png" width="19" height="19" />
                </router-link>
              </td>
              <td  width="100"><template v-if = "row.deleteFlg ==0">普通
                  </template>
                　<template v-else-if = "row.deleteFlg ==1">
                    <font color="red">使用不可</font>
                  </template>
                  <template v-else>
                   ??
                  </template>
            </td>
              <td>{{ row.memberName }}({{ row.memberID }})</td>
              <td><template v-if = "row.userType ==1">
                  ｼｽﾃﾑ管理者
                  </template>
                　<template v-else-if = "row.userType ==3">
                  管理者
                  </template>
                  <template v-else-if = "row.userType ==5">
                  リーダー
                  </template>
                  <template v-else-if = "row.userType ==7">
                  一般
                  </template>
                　<template v-else-if = "row.userType ==8">
                  スタッフ
                  </template>
                  <template v-else-if = "row.userType ==9">
                  派遣社員
                  </template>
                  <template v-else>
                   ??
                  </template>
            </td>

            </tr>
          </tbody>
        </table>
      </div><br/>
      <button @click="$router.push({ name: 'mains', params: { } });" class="btn-mid" style="width:250px;">メイン画面へ</button><br/>
    </form>
  </div>
</template>

<script>
  export default {
    name: "userManage",
    data() {
      return {
          divVisible: false,
          user:  { memberID: '', memberName: '', userType: '', deleteFlg: '' },
          rows:  null,
      }
    },
    mounted() {
      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.src = '/static/js/common.js?v=17';
      document.body.appendChild(s);
      this.init();
    },
    methods: {
      init: function () {
        var self = this;

        // サーバ側処理呼び出す
        new Promise(function (request, response) {
          var data = self.$route.params;
          common.getAxios().post(process.env.API_URL +"/api/UserManageInit", data)
            .then(function (res) {
              if (res.data) {
                self.user = res.data.user;
                self.rows = res.data.rows;

                self.divVisible = true;
              }
            })
            .catch(function (err) {
              alert(err);
            });
        });

      },
    }

  };
</script>



// WEBPACK FOOTER //
// userManage.vue?592cd557